import { DeliveryMode } from '../../../../../../services/exports/Constants';

export default {
  types: {
    circle: 'Okrąg',
    polygon: 'Wielokąt',
    zip: 'Kod pocztowy',
  },
  fields: {
    name: {
      label: 'Nazwa',
    },
    color: {
      label: 'Kolor',
    },
    min_threshold: {
      label: 'Minimalna kwota zamówienia',
    },
    max_threshold: {
      label: 'Maksymalna kwota zamówienia',
    },
    fee: {
      [DeliveryMode.Internal]: {
        label: 'Opłata za dostawę',
      },
      [DeliveryMode.External]: {
        label: 'Opłata pokrywana przez restaurację',
      },
    },
    zip_codes: {
      label: 'Kody pocztowe (każdy w nowej linii)',
    },
  },
  labels: {
    hidden: '(ukryta)',
  },
  buttons: {
    save: 'Zapisz',
    cancel_changes: 'Anuluj zmiany',
    add_max_order_amount: 'Dodaj maks. kwotę zamówienia',
  },
  modals: {
    delete_confirmation: {
      title: 'Czy na pewno chcesz usunąć {{name}}',
    },
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian dla {{name}}',
    delivery_zone_got_updated: 'Pomyślnie zapisano zmiany dla {{name}}',
    failed_to_delete_delivery_zone: 'Nie udało się usunąć {{name}}',
    delivery_zone_got_deleted: 'Pomyślnie usunięto {{name}}',
  },
};
